import React,{ useEffect, useState } from 'react'
import { Form, Input, Button } from 'antd';
import { UserOutlined, UnlockOutlined  } from '@ant-design/icons';
import './login.css'
import cookie from 'react-cookies'
import JSEncrypt from 'jsencrypt'
import * as User from '@/common/api/user'
import * as AppVersionApi from '@/common/api/system/AppVersionApi'
import config from '@/config/index'
// import loginBox from '@/common/images/logo.png'
import loginBj from '@/common/images/loginbj.png'
import loginQh from '@/common/images/login_qh.jpg'
function Login(props) {
    const layout = {
        wrapperCol: { span: 24 }
    };
    const tailLayout = {
        wrapperCol: { span: 24 }
    };
    const [form] = Form.useForm()
    const [codeTimestamp, setCodeTimestamp] = useState(new Date().getTime())
    const [loading, setLoding] = useState(false)
    const [qrCodeUrl,setQrCodeUrl] = useState(undefined)
    const [CODE_IMG, setCODEIMG] = useState(undefined)
    function getLoginCodeInfo () { // 获取验证码方法
        const params = {
            randomStr: codeTimestamp,
            timestamp: codeTimestamp
        }
        User.getLoginCode(params).then(res => {
            if (res.code === 0) {
                setCODEIMG(
                    res.data
                )
            }
        })
    }
    // 查询app二维码
    const handleQueryQrCode = () => {
        AppVersionApi.getLastAppQrCode().then(res=>{
            if(res.code === 0){
                setQrCodeUrl(res.data)
            }else{
                setQrCodeUrl(undefined)
            }
        })
    }
    useEffect(() =>{
        getLoginCodeInfo()
        handleQueryQrCode()
    }, [])
    //校验通过
    const onFinish = values => {
        let encryptor = new JSEncrypt()
        if (values) {
            setLoding(() => {return true})
            User.getRsaPublicKey().then(res => {
                if (res.code === 0) {
                    encryptor.setPublicKey(res.data)
                    const params = {
                        username: values.username,
                        password: encryptor.encrypt(values.password),
                        scope: 'web'
                    }
                    User.userLogin(params).then(res => {
                        if (res.code === 0) {
                            cookie.save('user_token', res.data.access_token)
                            setCodeTimestamp(new Date().getTime())
                            React.$message.success('登录成功')
                            if (config.pubshAdd === 'tj') {
                                User.getUserInfo().then(res => {
                                    sessionStorage.setItem('FY_SCMP_USER_ID',res.data.id)
                                    sessionStorage.setItem('FY_SCMP_USER_DEPT_ID',res.data.deptList && res.data.deptList.length > 0 ? res.data.deptList[0].id : res.data.deptId)
                                    res.data.menuList.some(item => {
                                        if (item.menuCode === 'home') {
                                            props.history.push('/home')
                                            return true
                                        } else {
                                            props.history.push('/home1')
                                        }
                                    })
                                })
                            } else {
                                props.history.push('/home1')
                            }
                        } else {
                            getLoginCodeInfo()
                        }
                        setLoding(() => {return false})

                    })
                } else {
                    React.$message.error('失败')

                }
            })
        }
    };
    // 校验不通过
    const onFinishFailed = () => {

    };
    const getCodeIsStatus = (rule, value, callback) => {
        if (value === '' || value === undefined) {
            callback('请输入验证码')
            return
        }
        if (value.length < 4 || value.length > 4) {
            return
        }
        const params = {
            code: form.getFieldValue('checkCode'),
            randomStr: codeTimestamp
        }
        User.getIsLoginCodeStatus(params).then((res) => {
            if (res.code === 0) {
                callback()
            } else {
                callback('验证码错误')
            }
        })
    };
    /**
     * function isImg
     * 验证码图片为空img标签隐藏
     */
    function Img () {
        if (CODE_IMG !== undefined ) {
            return <img src={`${CODE_IMG}`} />
        } else {
            return  ''
        }
    }
   return (
       <div className="login"
           style={{ minHeight: '100vh' }}
       >
           {
               config.pubshAdd === 'tj' ?
               <div className="qr-code" >{qrCodeUrl ? <img src={qrCodeUrl}/> : null}</div> : null
           }
               <Form
                   {...layout}
                   form={form}
                   name="login"
                   onFinish={onFinish}
                   onFinishFailed={onFinishFailed}
               >
                   <div className="login-webInfo">
                       <img src={config.pubshAdd === 'tj' ? loginBj : loginQh} />
                       {/* <h1>智慧城市监控平台</h1> */}
                   </div>
                   <div className="line"></div>
                   <Form.Item
                       name="username"
                       required={false}
                       rules={[{ required: true, message: '请输入账号' }]}
                   >
                       <Input placeholder="请输入账号" prefix={<UserOutlined className="site-form-item-icon" />} />
                   </Form.Item>

                   <Form.Item
                       name="password"
                       required={false}
                       rules={[{ required: true, message: '请输入密码' }]}
                   >
                       <Input.Password placeholder="请输入密码" prefix={<UnlockOutlined className="site-form-item-icon" />} />
                   </Form.Item>
                   <div style={{Position: 'relative'}}>
                       <Form.Item
                           name="checkCode"
                           required={false}
                           rules={[{ validator: (rule, value, callback) => getCodeIsStatus(rule, value, callback) }]}
                       >
                           <Input placeholder="请输入验证码" style={{width: '68%'}} />
                       </Form.Item>
                       <div className="checkCode"
                           onClick={getLoginCodeInfo}
                       >
                           <Img />
                           {/* <img src={`${CODE_IMG}`} /> */}
                       </div>
                   </div>
                   <Form.Item {...tailLayout} className="login-button">
                           <Button htmlType="submit"
                               loading={loading}
                               type="primary"
                           >
                               登录
                           </Button>
                   </Form.Item>
               </Form>
       </div>
   )
}
export default Login
